import { render, staticRenderFns } from "./WhitelabelSettingsIcon.vue?vue&type=template&id=c899b028&scoped=true"
import script from "./WhitelabelSettingsIcon.vue?vue&type=script&lang=js"
export * from "./WhitelabelSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c899b028",
  null
  
)

export default component.exports